<div class="tenant-tags-container mt-4">
  <h2>Tenant Tags</h2>

  <div class="mb-2">
    <input
      type="text"
      pInputText
      [(ngModel)]="newTagText"
      placeholder="Enter tag name"
      class="tag-input"
    />
    <button
      pButton
      type="button"
      icon="pi pi-plus"
      (click)="addTag()"
      class="ms-2"
    ></button>
  </div>

  <p-table
    #dt1
    [value]="tags"
    class="p-0"
    [globalFilterFields]="['name', 'description']"
  >
    <ng-template pTemplate="header">
      <tr>
        <th [attr.colspan]="innerWidth < 1200 ? 2 : 1">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-search"></i>
            </p-inputgroup-addon>
            <input
              type="text"
              pInputText
              (input)="onGlobalFilter(dt1, $event)"
              placeholder="{{ 'search' | transloco }}"
            />
          </p-inputgroup>
        </th>
        <th class="d-none d-xl-table-cell"></th>
      </tr>
      <tr>
        <th pSortableColumn="title" class="col-6 col-xl-3">
          {{ "title" | transloco }} <p-sortIcon field="title"></p-sortIcon>
        </th>
        <th pSortableColumn="createdAt" class="col-5 col-xl-2">
          {{ "created" | transloco }}
          <p-sortIcon field="createdAt"></p-sortIcon>
        </th>
        <th class="col-1"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-tag>
      <tr>
        <td>{{ tag.title }}</td>
        <td>{{ tag.createdAt | date : "dd-MM-yyyy" }}</td>
        <td>
          <div style="display: flex; justify-content: end">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              class="small-icon-button d-flex justify-content-center align-items-center p-0"
              style="width: 32px; height: 32px; font-size: 20px; line-height: 1"
            >
              <img src="assets/img/dots-vertical.svg" alt="Menu Icon" />
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="editTag = tag">
                {{ "edit" | transloco }}
              </button>
              <button
                mat-menu-item
                class="text-danger"
                (click)="deleteConf = { id: tag.id, name: tag.title }"
              >
                {{ "delete" | transloco }}
              </button>
            </mat-menu>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<app-confirm-delete
  id="deleteusermodal"
  *ngIf="deleteConf"
  [deleteCandidate]="deleteConf.name"
  (confirm)="handleDeleteClick(deleteConf.id); deleteConf = null"
  (cancel)="deleteConf = null"
></app-confirm-delete>

<app-edit-modal
  *ngIf="editTag"
  [editField]="editTag.title"
  (save)="updateTag($event)"
  (cancel)="editTag = undefined"
>
</app-edit-modal>
